module.exports = __webpack_public_path__ + "img/taxi_day_down.bfa66a2a.svg";